import React from "react";
import GridItemProps from "./props";
import "./style.scss";

const GridItem = ({ children, span = 4, index }: GridItemProps) => {
  return (
    <div className="grid-item" style={{ gridColumn: `span ${span}` }} data-e2e={`grid-item-${index}`}>
      {children}
    </div>
  );
};

export default GridItem;